import {sum} from "../../utils/collections";

import {getCartPurchaseLines} from "./get-cart-purchase-lines";

export const getCartTotalPurchaseAmount = (cart) => (
    sum(getCartPurchaseLines(cart), (line) => line.value)
);
